import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Sparkles } from "lucide-react";
import { mediaUrl } from "../media";

export default function ServicesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/services").then(r => setItems(r.data)); }, []);

  const grouped = items.reduce((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s); return acc;
  }, {});

  return (
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="text-center mb-12">
        <div className="tag-sun mb-3 inline-block">ESPECIALIDADES</div>
        <h1 className="font-serif text-4xl sm:text-5xl">Todas as especialidades</h1>
        <p className="text-[color:var(--ink-500)] mt-3 max-w-xl mx-auto">
          Clique em qualquer serviço para agendar diretamente.
        </p>
      </div>

      {Object.entries(grouped).map(([cat, list]) => (
        <div key={cat} className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <Sparkles size={16} className="text-[color:var(--sun-600)]"/>
            <h2 className="font-serif text-2xl">{cat}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {list.map(s => (
              <Link key={s.service_id} to={`/agendar?service=${s.service_id}`} className="card-arya overflow-hidden flex flex-col hover:shadow-xl transition-shadow cursor-pointer" data-testid={`svc-${s.service_id}`}>
                {s.image_url && <div className="aspect-[4/3] overflow-hidden"><img src={mediaUrl(s.image_url)} alt={s.title} className="w-full h-full object-cover" data-testid={`svc-img-${s.service_id}`}/></div>}
                <div className="p-6 flex flex-col flex-1">
                <span className="tag-sun w-fit">{s.duration_min} MIN</span>
                <h3 className="font-serif text-2xl mt-3">{s.title}</h3>
                <p className="text-sm text-[color:var(--ink-500)] mt-2 flex-1">{s.description}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="font-serif text-xl text-[color:var(--sun-700)]">R$ {s.price.toFixed(2).replace('.', ',')}</span>
                  <span className="btn-gold !py-2 !px-4 text-sm" data-testid={`svc-book-${s.service_id}`}>Agendar</span>
                </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
